var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goodsList"},_vm._l((_vm.goodsListData),function(item,index){return _c('goodsOne',{key:index,attrs:{"goodsListItemData":item},nativeOn:{"click":function($event){return _vm.toGoodsDetails(item)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }